import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LayoutAdmin } from './components';
import AuthGuard from './components/layouts/AuthGuard';
import Page404 from './pages/404';
import { adminPrivateRoutes, adminPublicRoutes } from './routes';

function RootApp({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <RootApp>
        <Routes>
          <Route path="*" element={<Page404 />} />

          {/* private sites */}
          <Route
            element={
              <AuthGuard>
                <LayoutAdmin />
              </AuthGuard>
            }
          >
            {adminPrivateRoutes.map((item) => {
              return <Route key={item.path} path={item.path} element={item.element} />;
            })}
          </Route>

          {/* public sites */}
          <Route>
            {adminPublicRoutes.map((item) => {
              return <Route key={item.path} path={item.path} element={item.element} />;
            })}
          </Route>
        </Routes>
      </RootApp>
    </BrowserRouter>
  );
}

export default App;
